import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityAccessAnomalyAlertsExportSlice } from './post';

export const coreDataSecurityAccessAnomalyAlertsExportReducers = combineReducers({
	post: postCoreDataSecurityAccessAnomalyAlertsExportSlice.asyncReducers
});

export const coreDataSecurityAccessAnomalyAlertsExportWatchers = combineAllWatchers([
	postCoreDataSecurityAccessAnomalyAlertsExportSlice.asyncWatchers
]);
